import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.4.37_typescript@5.9.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];